

export const quiz =  {

  "appLocale": {
  "landingHeaderText": "HTML5 Assessment (<questionLength> Questions)",
  "question": "Question",
  "startQuizBtn": "Start Assessment",
  "resultFilterAll": "All",
  "resultFilterCorrect": "Correct",
  "resultFilterIncorrect": "Incorrect",
  "prevQuestionBtn": "Prev",
  "nextQuestionBtn": "Next",
  "resultPageHeaderText": "You have completed the assessment. You got <correctIndexLength> out of <questionLength> questions."
},

  "quizTitle": "HTML 5",
  "quizSynopsis": "This assessment is designed to challenge your understanding of HTML elements, tags, attributes, and their usage in creating web pages. If you have previously taken this assessment, your previous score will be replaced with your recent score. Before you begin please ensure you have access to a stable internet connection.",
  "nrOfQuestions": "30",
  "questions": [
    {
      "question": "What does HTML stand for?",
      "questionType": "text",
      // "questionPic": "https://codefussion.tech/elearning/assets/quiz-images/html.png", // if you need to display Picture in Question
      "answerSelectionType": "single",
      "answers": [
        "HyperText Mashup Language",
        "Hot Mail Language",
        "HyperText Markup Language",
        "None of the above"
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "HyperText Markup Language",
      "point": "5"
    },
    {
      "question": "What is the difference between an opening tag and a closing tag?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Closing tag has a / in the front.",
        "opening tag has a / in the front.",
        "There is no need for tags in HTML.",
        "There is not much difference."
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "Closing tag has a / in the front.",
      "point": "5"
    },
    {
      "question": "Who is responsible for setting the Web standards?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Google",
        "Codeflare",
        "Microsoft",
        "The World Wide Web Consortium"
      ],
      "correctAnswer": "4",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "The World Wide Web Consortium",
      "point": "5"
    },
    {
      "question": "What type of tag is this &lt;br  /&gt; ?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Broken tag",
        "Self-closing tag",
        "Heading tag",
        "None of the above",
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "Self-closing tag",
      "point": "5"
    },
    {
      "question": "What does &lt;a href = ”http://www.codeflarelimited.com“  title = ”Link to Codeflare  ”target = ” _blank” > Codeflare  &lt;/a&gt; do?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Adds new video content",
        "Adds a link to the word 'codeflare'",
        "Adds a new Codeflare audio ",
        "Does nothing",
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "Adds a link to the word 'codeflare'",
      "point": "5"
    },
    {
      "question": "Choose the correct HTML element for the largest heading?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "<html>",
        "<heading>",
        "<h4>",
        "<h1>",
      ],
      "correctAnswer": "4",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "Adds a link to the word 'codeflare'",
      "point": "5"
    },
    {
      "question": "How would you add a background color in HTML?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "<bg>red</bg>",
        "<div style='background-color:red'></dv>",
        '<body bgcolor="red">',
        "<background>red</background>",
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '<body bg="red">',
      "point": "5"
    },
    {
      "question": "What does View Page Source(CTRL + U) do?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "Does nothing",
        "Enables PHP integration",
        "Shows JavaScript Code",
        "Shows HTML source code of the website",
      ],
      "correctAnswer": "4",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '<body bg="red">',
      "point": "5"
    },

    // {
    //   "question": "which of the following is the correct way to insert an image",
    //   "questionType": "photo",
    //   "answerSelectionType": "single",
    //   "answers": [
    //     "https://codefussion.tech/elearning/assets/quiz-questions-images/html-quiz-1.png",
    //     "https://codefussion.tech/elearning/assets/quiz-questions-images/html-quiz-2.png",
    //     "https://codefussion.tech/elearning/assets/quiz-questions-images/html-quiz-3.png",
    //     "https://codefussion.tech/elearning/assets/quiz-questions-images/html-quiz-4.png"
    //   ],
    //   "correctAnswer": "4",
    //   "messageForCorrectAnswer": "Correct answer. Good job.",
    //   "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
    //   "explanation": "The image tag uses the src attribute and is a self-closing tag",
    //   "point": "5"
    // },
    {
      "question": "Which of the following statements about HTTML is true?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        "HTML stands for HyperText Markup Language",
        "HTML is the standard markup language for creating websites",
        "HTML uses markup tags to define elements within a web page",
        "None of the above"
      ],
      "correctAnswer": [1, 2, 3],
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "Selected statements are true",
      "point": "5"
    },
    {
      "question": "Choose the correct HTML element to define emphasized text",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        "<em>",
        "<i>",
        "<italic>",
        "<emp>",
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '<body bg="red">',
      "point": "5"
    },
    {
      "question": "How would you open a link in a new tab/browser window?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        '<a href="url" new>',
        '<a href="url" target="new">',
        '<a href="url" target="_blank">',
        '<a href="url" target="_new">',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '<a href="url" target="_blank">',
      "point": "5"
    },
    {
      "question": "How would you make a text bold?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        '<strong>',
        '<bold>',
        'All of the above',
        'None of the above',
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '<strong>',
      "point": "5"
    },
    {
      "question": "How wouuld you make a numbered list?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        '<dl>',
        '<ul>',
        '<ol>',
        '<list>',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '<ol>',
      "point": "5"
    },
    {
      "question": "Which of the following statements about html entities is true?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        "HTML entities are special codes used to display characters",
        "HTML entities have special meaniing",
        "There is nothing like HTML entities",
        "HTML entities start with & and end with ;"
      ],
      "correctAnswer": [1, 2, 4],
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "Selected statements are true",
      "point": "5"
    },
    {
      "question": "What is the correct way of using a checkbox?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        '<input type="checkbox">',
        '<input type="check">',
        '<checkbox>',
        '<check>',
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '<input type="checkbox">',
      "point": "5"
    },
    {
      "question": "How would you create a textarea?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        '<input type="textbox">',
        '<input type="textarea">',
        'textarea',
        '<textarea>',
      ],
      "correctAnswer": "4",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '<textarea>',
      "point": "5"
    },
    {
      "question": "How many heading tags are there in HTML?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        '1',
        '3',
        '6',
        '8',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '6',
      "point": "5"
    },
    {
      "question": "What is the purpose of using div tags in HTML?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'For creating different styles',
        'For creating separate headings',
        'There is no div tag',
        'For creating different sections',
      ],
      "correctAnswer": "4",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'For creating different sections',
      "point": "5"
    },
    {
      "question": "Which tag is used for creating a drop-down selection list?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        '<option>',
        '<select>',
        '<list>',
        '<dropdown>',
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '<select>',
      "point": "5"
    },
    {
      "question": "An iframe tag is used to display a web page within a web page",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'TRUE',
        'FALSE',
        'There is nothing like <iframe>',
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'TRUE',
      "point": "5"
    },
    {
      "question": "Which of the following elements can be used in HTML to create a table?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        '<table>, <tbody>, <trow>',
        '<table>, <tbody>, <tfooter>',
        '<table>, <tbody>, <tr>',
        'None of the above',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '<table>, <tbody>, <tr>',
      "point": "5"
    },
    {
      "question": "HTML comments start with &lt;!-- and end with --&gt;",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'TRUE',
        'FALSE',
      ],
      "correctAnswer": "1",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'TRUE',
      "point": "5"
    },
    {
      "question": "The 'title'  element must be located inside",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'The <body> element',
        'The <article> element',
        'The <footer> element',
        'The <head> element',
      ],
      "correctAnswer": "4",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'The <head> element',
      "point": "5"
    },
    {
      "question": "Which of the following statements about HTML forms is true?",
      "questionType": "text",
      "answerSelectionType": "multiple",
      "answers": [
        "Forms allow users to interact with a web page",
        "There is nothing like forms in HTML  ",
        "HTML forms are created using the <form>",
        "Forms can also include checkbox"
      ],
      "correctAnswer": [1, 3, 4],
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": "Selected statements are true",
      "point": "5"
    },
    {
      "question": "Block elements are normally displayed without starting a new line.",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'TRUE',
        'FALSE',
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'TRUE',
      "point": "5"
    },
    {
      "question": "Which of the following optional table tags is used to add a short description above a table?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        '<description>',
        '<title>',
        '<caption>',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '<caption>',
      "point": "5"
    },
    {
      "question": "How would you create a new paragraph in HTML?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        '<paragraph>',
        '<pre>',
        '<p>',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '<p>',
      "point": "5"
    },
    {
      "question": "What would you use to preserve formatting in HTML?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        '<code>',
        '<pre>',
        '<p>',
        '<h4>',
      ],
      "correctAnswer": "2",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '<pre>',
      "point": "5"
    },
    {
      "question": "Which of the following is not an HTML attribute?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        'alt',
        'target',
        'src',
        'fontSize',
      ],
      "correctAnswer": "4",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": 'fontSize',
      "point": "5"
    },
    {
      "question": "What HTML form input must be used to present multiple options, but select only one?",
      "questionType": "text",
      "answerSelectionType": "single",
      "answers": [
        '<input type="text">',
        '<input type="checkbox">',
        '<input type="radio">',
      ],
      "correctAnswer": "3",
      "messageForCorrectAnswer": "Correct answer. Good job.",
      "messageForIncorrectAnswer": "Incorrect answer. Please try again.",
      "explanation": '<input type="radio">',
      "point": "5"
    },
  ]
}
